module.exports = __webpack_public_path__ + "static/img/yijia.25e6b2bd.png";